import React from 'react'

import { CheckBoxInput, BodyText, Button } from '@pb/components'
import { getLabelFromStorage, isMonkiBrand, isArketBrand, isCosBrand } from '@pb/utils'
import cn from 'classnames'

import styles from '../ProductDetail.scss'

const renderReviewButton = (handleSubmitReview): JSX.Element | null => {
  if (isArketBrand || isCosBrand) {
    return (
      <>
        <div className={styles.buttonGroup}>
          <Button
            Tag="button"
            className={cn(isCosBrand && styles.upperCase)}
            onClick={handleSubmitReview}
          >
            {getLabelFromStorage('profile.unreviewedproducts.review.page.send.review')}
          </Button>
        </div>
        <BodyText meta={isCosBrand} className={styles.privacyPolicyURL}>
          * {getLabelFromStorage('profile.unreviewedproducts.review.page.privacy.policy')}
        </BodyText>
      </>
    )
  }
  return (
    <>
      <BodyText className={styles.privacyPolicyURL}>
        * {getLabelFromStorage('profile.unreviewedproducts.review.page.privacy.policy')}
      </BodyText>

      <div>
        <Button Tag="button" onClick={handleSubmitReview}>
          {getLabelFromStorage('profile.unreviewedproducts.review.page.send.review')}
        </Button>
      </div>
    </>
  )
}

export const ReviewFooter = ({
  isAcceptTermsChecked,
  handleCheckBoxChange,
  isShowTermsError,
  handleSubmitReview,
}): React.ReactElement => {
  return (
    <div className={cn(styles.reviewFooter, isCosBrand && styles.alignLeft)}>
      <div className={styles.checkboxContainer}>
        <CheckBoxInput
          className={cn(isCosBrand && styles.acceptTerms)}
          name="acceptterms"
          shouldShowValidationIcon={false}
          label={
            <>
              <BodyText
                meta={isCosBrand}
                className={isShowTermsError && isCosBrand && styles.errorState}
              >
                {getLabelFromStorage('profile.unreviewedproducts.review.page.agree.to')}{' '}
                <a
                  className={cn(isMonkiBrand && styles.terms)}
                  href={`https://${document.domain}${window?.app?.options?.turnTo.legal[0].url1}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {getLabelFromStorage('profile.unreviewedproducts.review.page.terms.conditions')}
                </a>
              </BodyText>
              {isCosBrand && isShowTermsError && (
                <BodyText meta={isCosBrand} className={styles.errorState}>
                  {getLabelFromStorage('profile.unreviewedproducts.submit.review.validation.terms')}
                </BodyText>
              )}
            </>
          }
          checked={isAcceptTermsChecked}
          checkboxStyle={isCosBrand ? 'crossMark' : undefined}
          borderStyle="square"
          verticalAlign={isCosBrand ? 'top' : undefined}
          onChange={handleCheckBoxChange}
        />
      </div>
      {isShowTermsError && !isCosBrand && (
        <BodyText className={styles.errorMessage} meta={isCosBrand}>
          * {getLabelFromStorage('profile.unreviewedproducts.submit.review.validation.terms')}
        </BodyText>
      )}
      {renderReviewButton(handleSubmitReview)}
    </div>
  )
}
